import { render, staticRenderFns } from "./AssetPickerDialog.vue?vue&type=template&id=22b497c0&scoped=true"
import script from "./AssetPickerDialog.vue?vue&type=script&lang=ts"
export * from "./AssetPickerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b497c0",
  null
  
)

export default component.exports